module.exports = __webpack_public_path__ + "static/Dataownership-voter.6664eaad.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Dataownership-voter.png
// module id = 482
// module chunks = 265584890008614